import { MutableRefObject, useCallback, useEffect, useRef } from 'react';

import { IPopover, TPopoverModifiers } from '@gem/ui-kit';

import { useContextMenu } from 'APP/main/hooks/useContextMenu/useContextMenu';

interface IMessageActionsMenuPresenterProps {
  reference: MutableRefObject<HTMLElement | null>;
  onChange(popoverStatus: boolean): void;
}

interface IMessageActionsMenuPresenter {
  popover: IPopover<HTMLElement>;
  modifiers: TPopoverModifiers;
  targetClick: HTMLElement | null;
}

export const useMessageActionsMenuPresenter = ({
  reference,
  onChange,
}: IMessageActionsMenuPresenterProps): IMessageActionsMenuPresenter => {
  const { modifiers, popover } = useContextMenu();

  const targetClickRef = useRef<HTMLElement | null>(null);

  const clickHandler = useCallback(() => {
    popover.toggle();
  }, []);

  const contextMenuHandler = useCallback(() => {
    popover.close();
  }, []);

  useEffect(() => {
    onChange(popover.isOpened);
  }, [popover.isOpened]);

  useEffect(() => {
    if (!reference.current) {
      return;
    }

    popover.containerRef.current = reference.current;

    const referenceEl = reference.current;
    referenceEl.addEventListener('contextmenu', contextMenuHandler);
    referenceEl.addEventListener('click', clickHandler);

    return () => {
      referenceEl?.removeEventListener('contextmenu', contextMenuHandler);
      referenceEl?.removeEventListener('click', clickHandler);
    };
  }, [reference, clickHandler]);

  return {
    popover,
    modifiers,
    targetClick: targetClickRef.current,
  };
};
